export default __webpack_public_path__ + "static/Cardboard-Recycling-1776f3246f626025aef836764c11a532.jpg";